import Icon from '@/common/components/Icon';
import { formatToExactTimeDate } from '@/common/functions/dateFormater';
import {
	HoverInfo,
	InfoCard,
	InfoRow,
	OrderedCell,
} from '../LeadOrders.styles';

const OrderedInfo = ({ row }) => {
	const hasInfo = row.ordered_by || row.ordered_at;

	if (!hasInfo) {
		return row.ordered || 0;
	}

	return (
		<OrderedCell>
			{row.ordered || 0}
			<HoverInfo>
				<Icon name='info' size={12} />
				<InfoCard className='lead-order-info-card'>
					{row.ordered_by && <InfoRow>{row.ordered_by}</InfoRow>}
					{row.ordered_at && (
						<InfoRow>{formatToExactTimeDate(row.ordered_at)}</InfoRow>
					)}
				</InfoCard>
			</HoverInfo>
		</OrderedCell>
	);
};

export default OrderedInfo;
